module.exports = __webpack_public_path__ + "img/RU.a4823c35.svg";